import { Component, OnInit } from '@angular/core';
import { ProjectService } from 'src/app/services/project.service';
import { AngularFirestoreDocument } from '@angular/fire/firestore';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  count: number;
  banner: AngularFirestoreDocument<any>;

  constructor(public projectService: ProjectService) { }

  ngOnInit() {
    this.projectService.getBanner().valueChanges().subscribe(res => this.banner = res)
    setTimeout(() => {
      this.projectService.setVisits(this.banner['visits'])
    }, 5000)
  }

}
